import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const PUBLIC_COLLECTIONS_COLLECTION = 'publicCollections';

function sanitizeToy(toy = {}) {
  const price = Number(toy.price);
  const preorderPrice = Number(toy.preorder_price ?? toy.preorderPrice);
  return {
    id: toy.id || '',
    name: toy.name || '',
    brand: toy.brand || '',
    series: toy.series || '',
    type: toy.type || '',
    scale: toy.scale || '',
    code: toy.code || '',
    qty: toy.qty || 1,
    price: Number.isFinite(price) ? price : 0,
    preorder_price: Number.isFinite(preorderPrice) ? preorderPrice : 0,
    source: toy.source || '',
    note: toy.note || '',
    imageUrl: toy.imageUrl || '',
    createdDate: toy.createdDate || ''
  };
}

export const publicCollectionService = {
  async publishCollection(ownerId, toys = [], currency = 'USD') {
    if (!ownerId) {
      throw new Error('ownerId is required to publish a public collection');
    }

    const sanitizedItems = Array.isArray(toys)
      ? toys.map((toy) => sanitizeToy(toy))
      : [];

    const docRef = doc(db, PUBLIC_COLLECTIONS_COLLECTION, ownerId);
    await setDoc(docRef, {
      ownerId,
      currency,
      items: sanitizedItems,
      updatedAt: serverTimestamp()
    });
  },

  async getPublicCollection(ownerId) {
    if (!ownerId) {
      return null;
    }

    const docRef = doc(db, PUBLIC_COLLECTIONS_COLLECTION, ownerId);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) {
      return null;
    }
    return snapshot.data();
  }
};
